interface ErrorResponse {
    code: number;
    message: string;
}

export interface PlayerDataState {
    playerData: any | null;
    loading: boolean;
    confirmOTPError: ErrorResponse | null;
}

export enum PlayerActionTypes {
    GET_PLAYER_DATA         = "GET_PLAYER_DATA",
    GET_PLAYER_DATA_SUCCESS = "GET_PLAYER_DATA_SUCCESS",
    GET_PLAYER_DATA_ERROR   = "GET_PLAYER_DATA_ERROR",
}

export type PlayerCreateAction =
    | { type: PlayerActionTypes.GET_PLAYER_DATA }
    | { type: PlayerActionTypes.GET_PLAYER_DATA_SUCCESS; payload: any }
    | { type: PlayerActionTypes.GET_PLAYER_DATA_ERROR;   payload: ErrorResponse };